function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import CKEditor from '@ckeditor/ckeditor5-vue';
import '../Plugins/ckeditor/ckeditor.js'; // provides 'ClassicEditor' variable(see editorType in data)
import { markRaw } from 'vue';
export default {
  components: {
    ckeditor: CKEditor.component
  },
  emits: ['update:modelValue', 'focused', 'blurred'],
  props: {
    modelValue: String,
    height: {
      type: String,
      "default": "20vh"
    }
  },
  data: function data() {
    return {
      editorType: ClassicEditor,
      editor: {},
      //editor instance
      editorConfig: {
        fontFamily: {
          options: ["Calibri, Helvetica, sans-serif", "default", "Arial, Helvetica, sans-serif", "'Courier New', Courier, monospace", "Georgia, serif", "'Lucida Sans Unicode', 'Lucida Grande', sans-serif", "Tahoma, Geneva, sans-serif", "'Times New Roman', Times, serif", "'Trebuchet MS', Helvetica, sans-serif", "Verdana, Geneva, sans-serif"]
        },
        fontSize: {
          options: [9, 11, 13, 'default', 17, 19, 21, 24, 32],
          supportAllValues: true
        }
      }
    };
  },
  computed: {
    body: {
      get: function get() {
        return this.modelValue;
      },
      set: function set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    cssProps: function cssProps() {
      return {
        '--ck-editor-editable-height': this.height
      };
    }
  },
  methods: {
    setFocus: function setFocus() {
      this.editor.focus();
      // this.editor.editing.view.focus();
    },
    onEditorReady: function onEditorReady(editor) {
      this.editor = markRaw(editor); //markRaw for making it non reactive
    },
    /**
     * @param {Array} args 
     */
    execute: function execute(args) {
      var _this$editor;
      //args for search ['find','textToSearch']
      (_this$editor = this.editor).execute.apply(_this$editor, _toConsumableArray(args));
    },
    insertText: function insertText(text) {
      var _this = this;
      this.editor.model.change(function (writer) {
        writer.insertText(text, _this.editor.model.document.selection.getFirstPosition());
      });
      this.setFocus();
    }
  }
};